import { useState } from 'react'

import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

const DeleteVehicle = (props) => {
  const { open, handleClose, changeRender, idVehicle } = props
  const createDismissableSnackbar = useCustomSnackbar()

  function reset() {
    changeRender()
  }
  const [loading, setLoading] = useState(false)
  const onSubmit = async () => {
    setLoading(true)
    await interfaces.configInterface
      .deleteVehicle(idVehicle)
      .then(() => {
        createDismissableSnackbar('Vehiculo eliminado correctamente', {
          variant: 'success',
        })
        reset()
      })
      .finally(handleClose)
    setLoading(false)
  }

  return (
    <>
      <DialogComponent
        open={open}
        handleclose={handleClose}
        handleclosedisabled={loading}
        widthLarge="500px"
        title="¿Desea eliminar este Vehiculo?"
        disableChildHeight
        disableBackdropClick
        disableEscapeKeyDown
        actions={
          <>
            <CancelConfirmButtons
              onClickCancel={handleClose}
              onClickSubmit={onSubmit}
              disabledCancel={loading}
              disabledSubmit={loading}
              isLoading={loading}
            />
          </>
        }
      />
    </>
  )
}

export default DeleteVehicle
